import React, { useCallback } from 'react';
import {
  Box,
  Stack,
  Divider,
  Chip,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

const invTyps = [
  { id: 1, value: '매출', label: '매출', color: 'primary' },
  { id: 2, value: '매입', label: '매입', color: 'secondary' },
];

const osTranOptions = [
  { label: '전체', value: 'A' },
  { label: '해외', value: 'Y' },
  { label: '국내', value: 'N' },
];

const reqCompOptions = [
  { label: '전체', value: 'A' },
  { label: '발행완료', value: 'Y' },
  { label: '미발행', value: 'N' },
];

const TaxbillStatusList = ({ filters, onFilters }) => {
  const handleFilterBillType = useCallback(
    (value) => {
      onFilters('searchInvTyp', value);
    },
    [onFilters],
  );

  const handleFilterOsTran = (event, newValue) => {
    if (newValue === '' || newValue === null) {
      newValue = 'A';
    }
    onFilters('searchOsTran', newValue);
  };

  const handleFilterYn = (event, newValue) => {
    if (newValue === '' || newValue === null) {
      newValue = 'A';
    }
    onFilters('searchYn', newValue);
  };

  return (
    <Box className="status-chip-list"
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItem: 'center',
        m: 1,
      }}
    >
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}
      >
        <Box sx={{ mx: 1 }}>
          <ToggleButtonGroup
            size="small"
            color="primary"
            value={filters?.searchYn}
            exclusive
            onChange={handleFilterYn}
          >
            {reqCompOptions.map((reqComp) => (
              <ToggleButton key={reqComp.value} value={reqComp.value}>
                {reqComp.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Box>
        <Box sx={{ mx: 1 }}>
          <ToggleButtonGroup
            size="small"
            color="primary"
            value={filters?.searchOsTran}
            exclusive
            onChange={handleFilterOsTran}
          >
            {osTranOptions.map((osTran) => (
              <ToggleButton key={osTran.value} value={osTran.value}>
                {osTran.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Box>

        <Box sx={{ mx: 1 }}>
          {invTyps &&
            invTyps.map((st, index) => (
              <Chip
                sx={{ mr: 2 }}
                key={index}
                icon={<CircleIcon />}
                label={st.label}
                variant={
                  st.value === filters?.searchInvTyp ? 'contained' : 'outlined'
                }
                color={st.color}
                onClick={() => handleFilterBillType(st.value)}
              />
            ))}
        </Box>
        {/* <Box sx={{ mx: 1 }}>
                <Chip
                    icon={<CircleIcon />}
                    label="월별 조회"
                    variant={searchTyp ? 'contained' : 'outlined'}
                    color="info"
                    onClick={() => toggleSearchTyp()}
                />
            </Box> 
            <Box sx={{ mx: 1 }}>
          {useYns &&
            useYns.map((st, index) => (
              <Chip
                sx={{ mr: 2 }}
                key={index}
                icon={<CircleIcon />}
                label={st.label}
                variant={
                  st.value === filters?.searchYn ? 'contained' : 'outlined'
                }
                color={st.color}
                onClick={() => handleFilterStatus(st.value)}
              />
            ))}
        </Box>
            
            */}
      </Stack>
    </Box>
  );
};

export default TaxbillStatusList;
